<div class="seccionTable">
  <mat-card class="cardTable mat-elevation-z4">
    <div class="topTitle">
      <mat-card class="titleSeccion">Informe de movimientos</mat-card>
    </div>

    <!-- Filtros -->
    <div class="filtros" [formGroup]="filtrosForm">
      <mat-form-field appearance="fill">
        <mat-label>Fecha desde</mat-label>
        <input matInput [matDatepicker]="pickerDesde" formControlName="fechaDesde" />
        <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>
        <mat-datepicker #pickerDesde></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Fecha hasta</mat-label>
        <input matInput [matDatepicker]="pickerHasta" formControlName="fechaHasta" />
        <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
        <mat-datepicker #pickerHasta></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="tipo">
          <mat-option value="">Todos</mat-option>
          <mat-option value="gasto">Gasto</mat-option>
          <mat-option value="turno">Turno</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Médico</mat-label>
        <mat-select formControlName="idMedico">
          <mat-option value="">Todos</mat-option>
          <mat-option *ngFor="let medico of medicos" [value]="medico.id">
            {{ medico.name }} {{ medico.surname }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Paciente</mat-label>
        <mat-select formControlName="idPaciente">
          <mat-option value="">Todos</mat-option>
          <mat-option *ngFor="let paciente of pacientes" [value]="paciente.id">
            {{ paciente.name }} {{ paciente.surname }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Estado</mat-label>
        <mat-select formControlName="estado">
          <mat-option value="">Todos</mat-option>
          <mat-option value="pendiente">Pendiente</mat-option>
          <mat-option value="pagado">Pagado</mat-option>
          <mat-option value="fallido">Fallido</mat-option>
          <mat-option value="reembolsado">Reembolsado</mat-option>
          <mat-option value="anulado">Anulado</mat-option>
        </mat-select>
      </mat-form-field>

      <button class="buttonForm filtrarBtn" mat-raised-button (click)="filtrar()">
        <mat-icon>search</mat-icon> Filtrar
      </button>
      <button class="buttonForm limpiarBtn" mat-raised-button (click)="limpiarFiltros()">
        Limpiar
      </button>
    </div>

    <!-- Indicadores -->
    <div class="indicadores">
      <div class="indicador cobrado">
        <span class="indicador-label">Cobrado</span>
        <span class="indicador-valor">${{ totalCobrado | number : "1.2-2" }}</span>
      </div>
      <div class="indicador pendiente">
        <span class="indicador-label">Pendiente de cobrar</span>
        <span class="indicador-valor">${{ totalPendienteCobrar | number : "1.2-2" }}</span>
      </div>
      <div class="indicador gastado">
        <span class="indicador-label">Gastado</span>
        <span class="indicador-valor">${{ totalGastado | number : "1.2-2" }}</span>
      </div>
      <div class="indicador saldo" [ngClass]="{ negativo: saldo < 0 }">
        <span class="indicador-label">Saldo</span>
        <span class="indicador-valor">${{ saldo | number : "1.2-2" }}</span>
      </div>
    </div>

    <!-- Acciones -->
    <div class="acciones">
      <button class="buttonForm exportarBtn" mat-raised-button (click)="exportarExcel()" [disabled]="movimientos?.length === 0">
        <mat-icon>download</mat-icon> Exportar Excel
      </button>
    </div>

    <!-- Tabla -->
    <table
      mat-table
      [dataSource]="movimientos"
      *ngIf="movimientos?.length > 0"
    >
      <ng-container matColumnDef="fecha_hora">
        <th mat-header-cell *matHeaderCellDef>Fecha mov.</th>
        <td mat-cell *matCellDef="let element" data-label="Fecha mov.">
          {{ element.fecha_hora | date : "dd/MM/yyyy HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="fecha_turno">
        <th mat-header-cell *matHeaderCellDef>Fecha turno</th>
        <td mat-cell *matCellDef="let element" data-label="Fecha turno">
          <ng-container *ngIf="element.fecha_turno; else sinFechaTurno">
            {{ element.fecha_turno | date : "dd/MM/yyyy HH:mm" }}
          </ng-container>
          <ng-template #sinFechaTurno>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="medico">
        <th mat-header-cell *matHeaderCellDef>Médico</th>
        <td mat-cell *matCellDef="let element" data-label="Médico">
          {{ getNombreMedico(element) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="paciente">
        <th mat-header-cell *matHeaderCellDef>Paciente</th>
        <td mat-cell *matCellDef="let element" data-label="Paciente">
          <ng-container *ngIf="element.paciente; else sinPaciente">
            {{ getNombrePaciente(element) }}
          </ng-container>
          <ng-template #sinPaciente>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef>Tipo</th>
        <td mat-cell *matCellDef="let element" data-label="Tipo">
          <span [ngClass]="element.tipo === 'gasto' ? 'tipo-gasto' : 'tipo-turno'">
            {{ element.tipo | titlecase }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="sub_tipo">
        <th mat-header-cell *matHeaderCellDef>Sub-tipo</th>
        <td mat-cell *matCellDef="let element" data-label="Sub-tipo">
          <span *ngIf="element.sub_tipo" class="chip chip-{{ element.sub_tipo }}">
            {{ labelSubTipo(element.sub_tipo) }}
          </span>
          <span *ngIf="!element.sub_tipo">—</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="estado">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element" data-label="Estado">
          <span *ngIf="element.estado" class="chip estado-{{ element.estado }}">
            {{ labelEstado(element.estado) }}
          </span>
          <span *ngIf="!element.estado">—</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="monto_bruto">
        <th mat-header-cell *matHeaderCellDef>Monto bruto</th>
        <td mat-cell *matCellDef="let element" data-label="Monto bruto">
          ${{ (element.monto_bruto ?? element.monto) | number : "1.2-2" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="comision_medico">
        <th mat-header-cell *matHeaderCellDef>Comisión médico</th>
        <td mat-cell *matCellDef="let element" data-label="Comisión médico">
          <ng-container *ngIf="element.comision_medico !== null && element.comision_medico !== undefined && element.split !== false; else sinComisionMedico">
            ${{ element.comision_medico | number : "1.2-2" }}
          </ng-container>
          <ng-template #sinComisionMedico>—</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="descripcion">
        <th mat-header-cell *matHeaderCellDef>Descripción</th>
        <td mat-cell *matCellDef="let element" data-label="Descripción">
          {{ element.descripcion }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div class="sin-movimientos" *ngIf="movimientos?.length === 0">
      No hay movimientos para los filtros seleccionados
    </div>
  </mat-card>
</div>
